import { Box, styled } from "@mui/material";
import bgImage from "../../../../assets/images/speakers-bg.webp";

const StyledWrapper = styled(Box)(({ theme }) => ({
  width: "100%",
  position: "relative",
  backgroundColor: "#010207",
  height: "780px",
  display: "flex",
  alignItems: "center",
  overflow: "hidden",
  "&::before": {
    content: '""',
    position: "absolute",
    inset: 0,
    backgroundImage: `url(${bgImage})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "auto 100%",
    backgroundPosition: "right center",
    zIndex: 0,
    pointerEvents: "none",
  },
  "&::after": {
    content: '""',
    position: "absolute",
    inset: 0,
    background:
      "linear-gradient(90deg, #010207 0%, #010207 25%, rgba(1,2,7,0.85) 40%, rgba(1,2,7,0.4) 60%, rgba(1,2,7,0) 80%)",
    zIndex: 1,
    pointerEvents: "none",
  },
  [theme.breakpoints.down("lg")]: {
    height: "640px",
  },
  [theme.breakpoints.down("md")]: {
    height: "560px",
  },
  [theme.breakpoints.down("sm")]: {
    height: "auto",
    minHeight: "400px",
    padding: "50px 0",
    "&::before": {
      backgroundSize: "cover",
      backgroundPosition: "center right",
      opacity: 0.55,
    },
    "&::after": {
      background:
        "linear-gradient(180deg, rgba(1,2,7,0.85) 0%, rgba(1,2,7,0.6) 100%)",
    },
  },
  ".speakers-content-container": {
    position: "relative",
    zIndex: 2,
  },
  ".speakers-text": {
    display: "flex",
    flexDirection: "column",
    gap: "28px",
    maxWidth: "500px",
    [theme.breakpoints.down("md")]: {
      maxWidth: "440px",
      gap: "20px",
    },
    [theme.breakpoints.down("sm")]: {
      maxWidth: "none",
      gap: "16px",
    },
  },
  ".speakers-title": {
    color: theme.palette.white.main,
    textAlign: "left",
    textTransform: "uppercase",
  },
  ".speakers-description": {
    color: `${theme.palette.white.main} !important` as string,
    textAlign: "left !important" as "left",
    maxWidth: "none !important" as "none",
    [theme.breakpoints.down("sm")]: {
      textAlign: "left !important" as "left",
    },
  },
}));

export default StyledWrapper;
